var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconResponsiveDesignEwq2Zpk3Gn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ADEBF6;}\n\t.st1{fill:#CFDBE5;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{opacity:0.5;}\n\t.st4{fill:#45525B;}\n\t.st5{fill:#192E2D;}\n\t.st6{fill:#EAE9E8;}\n\t.st7{fill:#FF916E;}\n\t.st8{fill:#FDFBF2;}\n\t.st9{fill:#F2F2F2;}\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill:#45525B;}\n\t.st11{fill-rule:evenodd;clip-rule:evenodd;fill:#FEFDFA;}\n\t.st12{fill-rule:evenodd;clip-rule:evenodd;fill:#192E2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1494_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90,25.4c-35.7,0-64.6,28.9-64.6,64.6c0,35.7,28.9,64.6,64.6,64.6c35.7,0,64.6-28.9,64.6-64.6 C154.6,54.3,125.7,25.4,90,25.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.8,56.8H82.8c-1.3,0-2.3,1-2.3,2.3v1.5c0,1.3,1,2.3,2.3,2.3h20.1c1.3,0,2.3-1,2.3-2.3v-1.5 C105.2,57.8,104.1,56.8,102.8,56.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.9,44.9H87.7c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1h29.2c1.7,0,3.1-1.4,3.1-3.1 C119.9,46.3,118.6,44.9,116.9,44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.7,44.9h-4.5c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1h4.5c1.7,0,3.1-1.4,3.1-3.1 C83.8,46.3,82.4,44.9,80.7,44.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.6,50.8H86.8c1.5,0,2.7,1.2,2.7,2.7v0.7c0,1.5-1.2,2.7-2.7,2.7h14.8c-1.5,0-2.7-1.2-2.7-2.7v-0.7 C98.9,52.1,100.1,50.8,101.6,50.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.9,122.5H69.3c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h47.6c1.5,0,2.8-1.3,2.8-2.8v-0.4 C119.7,123.8,118.4,122.5,116.9,122.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.8,134.1h-53c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h53c1.5,0,2.8-1.3,2.8-2.8v-0.4 C117.6,135.4,116.3,134.1,114.8,134.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.6,109.2h-4.8c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h4.8c1.5,0,2.8-1.3,2.8-2.8V112 C60.4,110.4,59.1,109.2,57.6,109.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.2,144H87c-1.4,0-2.6,1.2-2.6,2.6v0.1c0,1.4,1.2,2.6,2.6,2.6h14.2c1.4,0,2.6-1.2,2.6-2.6v-0.1 C103.8,145.2,102.6,144,101.2,144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.7,122.5h-8.6c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h8.6c1.5,0,2.8-1.3,2.8-2.8v-0.4 C63.5,123.8,62.2,122.5,60.7,122.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.5,128.3H70c1.5,0,2.6,1.2,2.6,2.6v0.7c0,1.5-1.2,2.6-2.6,2.6h43.5c-1.5,0-2.6-1.2-2.6-2.6V131 C110.8,129.5,112,128.3,113.5,128.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.7,140.1H87.1c0.9,0,1.7,0.8,1.7,1.7v0.4c0,0.9-0.8,1.7-1.7,1.7h13.6c-0.9,0-1.7-0.8-1.7-1.7v-0.4 C99,140.9,99.8,140.1,100.7,140.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.9,112.2H69.5c-1.5,0-2.8,1.3-2.8,2.8v0.4c0,1.5,1.3,2.8,2.8,2.8h16.4c1.5,0,2.8-1.3,2.8-2.8V115 C88.6,113.4,87.4,112.2,85.9,112.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.5,118.1H70.1c1.1,0,1.9,0.9,1.9,1.9v0.5c0,1.1-0.9,1.9-1.9,1.9h15.4c-1.1,0-1.9-0.9-1.9-1.9v-0.5 C83.6,119,84.5,118.1,85.5,118.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102,129.5c0-3.1,0-7.5,0-7.5h-6h-6c0,0,0,4.4,0,7.5c0,3.1-8.1,5.5-8.1,5.5H96h14.1 C110.1,135,102,132.6,102,129.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90,129.3h12c0-3.1,0-7.3,0-7.3H90C90,122,90,126.2,90,129.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M110.1,134.7H81.8c-0.7,0-1.2,0.5-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2h28.3c0.7,0,1.2-0.5,1.2-1.2 C111.3,135.3,110.8,134.7,110.1,134.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M133.4,67.5H58.5c-1.3,0-2.4,1.1-2.4,2.4v46.6h79.6V69.9C135.8,68.6,134.7,67.5,133.4,67.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 70.1,
    className: "st2",
    width: 72.1,
    height: 42.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M56.2,123.2c0,1.3,1.1,2.4,2.4,2.4h74.9c1.3,0,2.4-1.1,2.4-2.4v-7.1H56.2V123.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96,118.7c-1.2,0-2.1,1-2.1,2.2c0,1.2,0.9,2.2,2.1,2.2c1.2,0,2.1-1,2.1-2.2C98.1,119.7,97.1,118.7,96,118.7 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 70.1,
    className: "st1",
    width: 72.1,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 110.2,
    className: "st1",
    width: 72.1,
    height: 2.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 74,
    className: "st7",
    width: 72.1,
    height: 16.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.6,
    y: 75,
    className: "st8",
    width: 21.2,
    height: 10.8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.8,
    y: 86.7,
    className: "st4",
    width: 21,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 101.8,
    y: 88.6,
    className: "st4",
    width: 17.5,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "124,81.9 126,80.4 124,78.9  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.6,
    y: 75,
    className: "st8",
    width: 21.2,
    height: 10.8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.6,
    y: 86.7,
    className: "st4",
    width: 21,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.1,
    y: 88.6,
    className: "st4",
    width: 17.5,
    height: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "69.4,81.9 69.4,78.9 67.4,80.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.4,91.5c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5 C70.9,93.1,69.4,91.5,67.4,91.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.9,
    y: 100.2,
    className: "st1",
    width: 5.3,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 64.9,
    y: 102.3,
    className: "st1",
    width: 5.3,
    height: 1.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.5,91.5c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5 C90,93.1,88.4,91.5,86.5,91.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.9,
    y: 100.2,
    className: "st1",
    width: 5.3,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.9,
    y: 102.3,
    className: "st1",
    width: 5.3,
    height: 1.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.5,91.5c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5 C109.1,93.1,107.5,91.5,105.5,91.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.9,
    y: 100.2,
    className: "st1",
    width: 5.3,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 102.9,
    y: 102.3,
    className: "st1",
    width: 5.3,
    height: 1.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.6,91.5c-1.9,0-3.5,1.6-3.5,3.5c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5 C128.1,93.1,126.5,91.5,124.6,91.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 100.2,
    className: "st1",
    width: 5.3,
    height: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 102.3,
    className: "st1",
    width: 5.3,
    height: 1.4
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 104.7,
    className: "st5",
    width: 72.1,
    height: 5.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 105.6,
    className: "st9",
    width: 18.5,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 107.1,
    className: "st9",
    width: 18.5,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 108.5,
    className: "st9",
    width: 18.5,
    height: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.3,
    y: 105.6,
    className: "st9",
    width: 18.5,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.3,
    y: 107.1,
    className: "st9",
    width: 18.5,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.3,
    y: 108.5,
    className: "st9",
    width: 18.5,
    height: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 105.6,
    className: "st9",
    width: 18.5,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 107.1,
    className: "st9",
    width: 18.5,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 108.5,
    className: "st9",
    width: 18.5,
    height: 0.9
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M70.1,49.8H34.7c-1.4,0-2.6,1.2-2.6,2.6V99c0,1.4,1.2,2.6,2.6,2.6h35.4c1.4,0,2.6-1.2,2.6-2.6V52.4 C72.7,51,71.5,49.8,70.1,49.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.4,98.8c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1 C53.6,99.3,53,98.8,52.4,98.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 53.1,
    className: "st2",
    width: 33.9,
    height: 45.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 53.1,
    className: "st1",
    width: 33.9,
    height: 4.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 95.4,
    className: "st1",
    width: 33.9,
    height: 2.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 57.2,
    className: "st7",
    width: 33.9,
    height: 17.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 59.7,
    className: "st8",
    width: 11.8,
    height: 8.8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.4,
    y: 59.7,
    className: "st8",
    width: 11.8,
    height: 8.8
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 70.3,
    className: "st4",
    width: 12.3,
    height: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 72,
    className: "st4",
    width: 15,
    height: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.7,
    y: 70.3,
    className: "st4",
    width: 13,
    height: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.7,
    y: 72,
    className: "st4",
    width: 9.8,
    height: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "66.5,65.6 68.3,64.2 66.5,62.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "38.5,65.6 38.5,62.8 36.7,64.2  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.3,76.5c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2C44.5,78,43,76.5,41.3,76.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,76.5c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2C52,78,50.6,76.5,48.8,76.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.8,76.5c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2C67,78,65.6,76.5,63.8,76.5 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.3,76.5c-1.8,0-3.2,1.4-3.2,3.2c0,1.8,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2 C59.5,78,58.1,76.5,56.3,76.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 84.4,
    className: "st1",
    width: 4.8,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 86.4,
    className: "st1",
    width: 4.8,
    height: 1.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.4,
    y: 84.4,
    className: "st1",
    width: 4.8,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 46.4,
    y: 86.4,
    className: "st1",
    width: 4.8,
    height: 1.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 84.4,
    className: "st1",
    width: 4.8,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 86.4,
    className: "st1",
    width: 4.8,
    height: 1.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.4,
    y: 84.4,
    className: "st1",
    width: 4.8,
    height: 1.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 61.4,
    y: 86.4,
    className: "st1",
    width: 4.8,
    height: 1.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 89.6,
    className: "st4",
    width: 33.9,
    height: 5.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 90.6,
    className: "st9",
    width: 8.7,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 92.1,
    className: "st9",
    width: 8.7,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 93.6,
    className: "st9",
    width: 8.7,
    height: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 90.6,
    className: "st9",
    width: 8.7,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 92.1,
    className: "st9",
    width: 8.7,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 93.6,
    className: "st9",
    width: 8.7,
    height: 0.9
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57.8,
    y: 90.6,
    className: "st9",
    width: 8.7,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57.8,
    y: 92.1,
    className: "st9",
    width: 8.7,
    height: 0.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 57.8,
    y: 93.6,
    className: "st9",
    width: 8.7,
    height: 0.9
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.3,41.7H78.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h11.9c0.2,0,0.4-0.2,0.4-0.4 C90.7,41.9,90.5,41.7,90.3,41.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M80.3,38.5h-1.2c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h1.2c0.2,0,0.4-0.2,0.4-0.4 C80.7,38.7,80.5,38.5,80.3,38.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.5,38.5h-4.5c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h4.5c0.2,0,0.4-0.2,0.4-0.4 C91.9,38.7,91.7,38.5,91.5,38.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86.8,36.4h-9.9c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h9.9c0.2,0,0.4-0.2,0.4-0.4 C87.2,36.6,87.1,36.4,86.8,36.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M82.5,32.1h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C82.8,32.3,82.7,32.1,82.5,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M87.1,32.1h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C87.4,32.3,87.3,32.1,87.1,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M91.7,32.1h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C92.1,32.3,91.9,32.1,91.7,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M95,32.1h-1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h1c0.2,0,0.4-0.2,0.4-0.4 C95.3,32.3,95.2,32.1,95,32.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M96,36.4h-3.2c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4H96c0.2,0,0.4-0.2,0.4-0.4 C96.4,36.5,96.2,36.4,96,36.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.5,35.1c-0.2,0-0.4,0.2-0.4,0.4v2.7c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4v-2.7 C94.8,35.2,94.7,35.1,94.5,35.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130.9,57.3h-10.6c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4h10.6c0.2,0,0.4-0.2,0.4-0.4 S131.1,57.3,130.9,57.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.1,53.5h-3.4c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h3.4c0.2,0,0.4-0.2,0.4-0.4 C117.5,53.7,117.3,53.5,117.1,53.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.5,59.4h-17.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h17.1c0.2,0,0.4-0.2,0.4-0.4 C132.9,59.6,132.7,59.4,132.5,59.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.6,63.6h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C112,63.7,111.9,63.6,111.6,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M120.9,63.6h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C121.2,63.7,121.1,63.6,120.9,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M116.2,63.6h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C116.6,63.7,116.5,63.6,116.2,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M125.5,63.6h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C125.8,63.7,125.7,63.6,125.5,63.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M130.1,63.6h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C130.5,63.7,130.3,63.6,130.1,63.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M112.4,58.1h-2.8c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.8c0.2,0,0.4-0.2,0.4-0.4 C112.8,58.3,112.7,58.1,112.4,58.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111,56.8c-0.2,0-0.4,0.2-0.4,0.4v2.6c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4v-2.6 C111.3,57,111.2,56.8,111,56.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46.1,118h-9.7c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h9.7c0.2,0,0.4-0.2,0.4-0.4 C46.5,118.1,46.3,118,46.1,118z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M37.9,114.6h-1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h1c0.2,0,0.4-0.2,0.4-0.4 C38.3,114.8,38.1,114.6,37.9,114.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M47.1,114.6h-3.7c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h3.7c0.2,0,0.4-0.2,0.4-0.4 C47.4,114.8,47.3,114.6,47.1,114.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M43.3,112.4h-8.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h8.1c0.2,0,0.4-0.2,0.4-0.4 C43.7,112.6,43.5,112.4,43.3,112.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.1,107.9h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C40.5,108,40.3,107.9,40.1,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.3,107.9H47c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C49.7,108,49.5,107.9,49.3,107.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M44.7,107.9h-2.3c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4h2.3c0.2,0,0.4-0.2,0.4-0.4 C45.1,108,44.9,107.9,44.7,107.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51,112.3h-3.1c-0.2,0-0.4,0.2-0.4,0.4c0,0.2,0.2,0.4,0.4,0.4H51c0.2,0,0.4-0.2,0.4-0.4 C51.4,112.5,51.2,112.3,51,112.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M49.5,111c-0.2,0-0.4,0.2-0.4,0.4v2.8c0,0.2,0.2,0.4,0.4,0.4c0.2,0,0.4-0.2,0.4-0.4v-2.8 C49.9,111.1,49.7,111,49.5,111z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M134.4,108.4h-11.9c-1.6,0-2.9,1.3-2.9,2.9v26.8c0,1.6,1.3,2.9,2.9,2.9h11.9c1.6,0,2.9-1.3,2.9-2.9v-26.8 C137.2,109.7,135.9,108.4,134.4,108.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.1,
    y: 111.3,
    className: "st11",
    width: 16.6,
    height: 27.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.7,
    y: 110.2,
    className: "st12",
    width: 3.4,
    height: 0.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M128.4,109.2c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3c0.2,0,0.3-0.1,0.3-0.3 C128.7,109.3,128.6,109.2,128.4,109.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M128.4,139c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7S128.8,139,128.4,139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.1,
    y: 111.3,
    className: "st1",
    width: 16.6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.1,
    y: 136.6,
    className: "st1",
    width: 16.6,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.1,
    y: 113.3,
    className: "st7",
    width: 16.6,
    height: 10.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 122.4,
    y: 114.7,
    className: "st8",
    width: 5.8,
    height: 5.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 128.9,
    y: 114.7,
    className: "st8",
    width: 5.8,
    height: 5.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.8,
    y: 120.9,
    className: "st4",
    width: 6,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.8,
    y: 121.9,
    className: "st4",
    width: 7.4,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 120.9,
    className: "st4",
    width: 6.3,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 121.9,
    className: "st4",
    width: 4.8,
    height: 0.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "135.3,118.2 136.2,117.4 135.3,116.6  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "121.6,118.2 121.6,116.6 120.7,117.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123,125.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C124.5,126.1,123.8,125.4,123,125.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.6,125.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C128.2,126.1,127.5,125.4,126.6,125.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134,125.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C135.5,126.1,134.8,125.4,134,125.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.3,125.4c-0.9,0-1.6,0.7-1.6,1.6c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C131.9,126.1,131.2,125.4,130.3,125.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.8,
    y: 129.2,
    className: "st1",
    width: 2.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.8,
    y: 130.2,
    className: "st1",
    width: 2.3,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 129.2,
    className: "st1",
    width: 2.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 130.2,
    className: "st1",
    width: 2.3,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 129.1,
    y: 129.2,
    className: "st1",
    width: 2.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 129.1,
    y: 130.2,
    className: "st1",
    width: 2.3,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.8,
    y: 129.2,
    className: "st1",
    width: 2.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 132.8,
    y: 130.2,
    className: "st1",
    width: 2.3,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.1,
    y: 132.6,
    className: "st4",
    width: 16.6,
    height: 3.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.1,
    y: 133.3,
    className: "st9",
    width: 4.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.1,
    y: 134.3,
    className: "st9",
    width: 4.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.1,
    y: 135.3,
    className: "st9",
    width: 4.3,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.1,
    y: 133.3,
    className: "st9",
    width: 4.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.1,
    y: 134.3,
    className: "st9",
    width: 4.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 126.1,
    y: 135.3,
    className: "st9",
    width: 4.3,
    height: 0.6
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 133.3,
    className: "st9",
    width: 4.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 134.3,
    className: "st9",
    width: 4.3,
    height: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 135.3,
    className: "st9",
    width: 4.3,
    height: 0.6
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconResponsiveDesignEwq2Zpk3Gn);
export default __webpack_public_path__ + "static/media/reshot-icon-responsive-design-EWQ2ZPK3GN.ac3300e2cb391bbf732b122be98b0e7e.svg";
export { ForwardRef as ReactComponent };